import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		access: '',
		refresh: '',
		userInfo: {
			id: '',
			corporateAccount: '',
			enterpriseFullName: '',
			enterpriseAbbreviation: '',
			businessLicenseNumber: '',
			address: '',
			enterpriseContact: '',
			enterpriseContactNumber: '',
			accumulatedRechargeAmount: '',
			enterpriseCurrentBalance: '',
			legalRepresentativeName: '',
			contactNumber: ''
		},

	},
	mutations: {
		mutUserCode: function(state, payload){
			state.access													= payload.accessToken;
			state.refresh													= payload.refreshToken;
		},
		mutUserInfo: function(state, payload){
			console.log(payload)
			console.log(payload.id)
			state.userInfo.id														= payload.id
			state.userInfo.corporateAccount							= payload.corporateAccount
			state.userInfo.enterpriseFullName						= payload.enterpriseFullName
			state.userInfo.enterpriseAbbreviation				= payload.enterpriseAbbreviation
			state.userInfo.businessLicenseNumber				= payload.businessLicenseNumber
			state.userInfo.address											= payload.address
			state.userInfo.enterpriseContact						= payload.enterpriseContact
			state.userInfo.enterpriseContactNumber			= payload.enterpriseContactNumber
			state.userInfo.accumulatedRechargeAmount		= payload.accumulatedRechargeAmount
			state.userInfo.enterpriseCurrentBalance			= payload.enterpriseCurrentBalance
			state.userInfo.legalRepresentativeName			= payload.legalRepresentativeName
			state.userInfo.contactNumber								= payload.contactNumber
		}
	},
	actions: {
		actUserCode: function(context, payload){
			return new Promise((resolve, reject) => {
				context.commit('mutUserCode', payload)
				resolve(payload)
			})
		},
		actUserInfo: function(context, payload){
			return new Promise((resolve, reject) => {
				context.commit('mutUserInfo', payload)
				resolve(payload)
			})
		},
	},
	getters: {

	},
	modules: {

	}
})
const userinfo  = JSON.parse(localStorage.getItem("userInfo"))||{}
store.state.userInfo=userinfo
export default store